import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const useCheckConnection = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleStatusChange = () => {
      setIsOnline(navigator.onLine);
    };

    window.addEventListener("online", handleStatusChange);

    window.addEventListener("offline", handleStatusChange);

    return () => {
      window.removeEventListener("online", handleStatusChange);
      window.removeEventListener("offline", handleStatusChange);
    };
  }, [isOnline]);

  useEffect(() => {
    if (!isOnline) {
      if (location.pathname !== "/home") {
        handleClick();
      }
    }
  }, [isOnline]);

  const handleClick = () => {
    navigate("/no-internet-connection");
  };

  return {
    isOnline,
  };
};

export default useCheckConnection;
